import { cn } from "@babybjorn/ui";
import type { FC, PropsWithChildren } from "react";
import * as s from "./LinkList.module.scss";

type LinkListProps = PropsWithChildren<{
	title?: string;
	privacySection?: boolean;
}>;

const LinkList: FC<LinkListProps> = ({ title, privacySection, children }) => {
	return (
		<div className={s.container}>
			{title && <h3>{title}</h3>}
			<ul className={cn(s.linkList, { [s.rowList]: privacySection })}>
				{children}
			</ul>
		</div>
	);
};

export default LinkList;
